import AHttpService from '@d-services/a-http-service/a-http-service';
import { addObjectToFormData } from '@d-shared/forms/forms';
import DropdownOptionsHelper from '@d-helpers/dropdown-options-helper';
import URLS from '@d-shared/urls/urls';

class CommentsService extends AHttpService {
  async getCommentReportReasons() {
    const response = await this._http.get(URLS.api.comments.commentReportReasons);
    const reportReasons = DropdownOptionsHelper.getTwoLevelOptionsListFromStrings(response.data);
    return reportReasons;
  }

  // Books
  async addBookCommentUpvote(bookSlug, commentId) {
    const url = URLS.api.comments.book.commentUpvote.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async deleteBookComment(bookSlug, commentId) {
    const url = URLS.api.comments.book.comment.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async getBookCommentUpvotes(bookSlug, commentId, page = 1) {
    const url = `${ URLS.api.comments.book.commentUpvotes.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getBookComments(bookSlug, page = 1) {
    const url = `${ URLS.api.comments.book.comments.replace('<book-slug>', bookSlug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getBookCommentsCount(bookSlug) {
    const url = URLS.api.comments.book.commentsCount.replace('<book-slug>', bookSlug);
    const response = await this._http.get(url);
    return response.data;
  }

  async postBookComment(bookSlug, comment, mentions = null, parentId = null) {
    const url = URLS.api.comments.book.comments.replace('<book-slug>', bookSlug);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    if (parentId) {
      commentData.comment.parent_id = parentId;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async removeBookCommentUpvote(bookSlug, commentId) {
    const url = URLS.api.comments.book.commentUpvote.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async reportBookComment(bookSlug, commentId, parentReason, childReason, description) {
    const url = URLS.api.comments.book.reportComment.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId);

    const reportData = {
      comment_report: {
        description: description,
        reason: childReason ? `${ parentReason }: ${ childReason }` : parentReason,
      },
    };

    const formData = new FormData();
    addObjectToFormData(reportData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async updateBookComment(bookSlug, commentId, comment, mentions = null) {
    const url = URLS.api.comments.book.comment.replace('<book-slug>', bookSlug).replace('<comment-id>', commentId);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.put(url, formData);
    return response.data;
  }
  // END Books

  // Posts
  async addPostCommentUpvote(postSlug, commentId) {
    const url = URLS.api.comments.post.commentUpvote.replace('<post-slug>', postSlug).replace('<comment-id>', commentId);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async deletePostComment(postSlug, commentId) {
    const url = URLS.api.comments.post.comment.replace('<post-slug>', postSlug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async getPostCommentUpvotes(postSlug, commentId, page = 1) {
    const url = `${ URLS.api.comments.post.commentUpvotes.replace('<post-slug>', postSlug).replace('<comment-id>', commentId) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getPostComments(postSlug, page = 1) {
    const url = `${ URLS.api.comments.post.comments.replace('<post-slug>', postSlug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getPostCommentsCount(postSlug) {
    const url = URLS.api.comments.post.commentsCount.replace('<post-slug>', postSlug);
    const response = await this._http.get(url);
    return response.data;
  }

  async postPostComment(postSlug, comment, mentions = null, parentId = null) {
    const url = URLS.api.comments.post.comments.replace('<post-slug>', postSlug);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    if (parentId) {
      commentData.comment.parent_id = parentId;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async removePostCommentUpvote(postSlug, commentId) {
    const url = URLS.api.comments.post.commentUpvote.replace('<post-slug>', postSlug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async reportPostComment(postSlug, commentId, parentReason, childReason, description) {
    const url = URLS.api.comments.post.reportComment.replace('<post-slug>', postSlug).replace('<comment-id>', commentId);

    const reportData = {
      comment_report: {
        description: description,
        reason: childReason ? `${ parentReason }: ${ childReason }` : parentReason,
      },
    };

    const formData = new FormData();
    addObjectToFormData(reportData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async updatePostComment(postSlug, commentid, comment, mentions = null) {
    const url = URLS.api.comments.post.comment.replace('<post-slug>', postSlug).replace('<comment-id>', commentid);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.put(url, formData);
    return response.data;
  }
  // END Posts

  // User reviews
  async addUserReviewCommentUpvote(slug, commentId) {
    const url = URLS.api.comments.userReview.commentUpvote.replace('<slug>', slug).replace('<comment-id>', commentId);
    const response = await this._http.post(url, null);
    return response.data;
  }

  async deleteUserReviewComment(slug, commentId) {
    const url = URLS.api.comments.userReview.comment.replace('<slug>', slug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async getUserReviewCommentUpvotes(slug, commentId, page = 1) {
    const url = `${ URLS.api.comments.userReview.commentUpvotes.replace('<slug>', slug).replace('<comment-id>', commentId) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getUserReviewComments(slug, page = 1) {
    const url = `${ URLS.api.comments.userReview.comments.replace('<slug>', slug) }?page=${ page }`;
    const response = await this._http.get(url);
    return response.data;
  }

  async getUserReviewCommentsCount(slug) {
    const url = URLS.api.comments.userReview.commentsCount.replace('<slug>', slug);
    const response = await this._http.get(url);
    return response.data;
  }

  async postUserReviewComment(slug, comment, mentions = null, parentId = null) {
    const url = URLS.api.comments.userReview.comments.replace('<slug>', slug);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    if (parentId) {
      commentData.comment.parent_id = parentId;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async removeUserReviewCommentUpvote(slug, commentId) {
    const url = URLS.api.comments.userReview.commentUpvote.replace('<slug>', slug).replace('<comment-id>', commentId);
    const response = await this._http.delete(url);
    return response.data;
  }

  async reportUserReviewComment(slug, commentId, parentReason, childReason, description) {
    const url = URLS.api.comments.userReview.reportComment.replace('<slug>', slug).replace('<comment-id>', commentId);

    const reportData = {
      comment_report: {
        description: description,
        reason: childReason ? `${ parentReason }: ${ childReason }` : parentReason,
      },
    };

    const formData = new FormData();
    addObjectToFormData(reportData, formData);

    const response = await this._http.post(url, formData);
    return response.data;
  }

  async updateUserReviewComment(slug, commentid, comment, mentions = null) {
    const url = URLS.api.comments.userReview.comment.replace('<slug>', slug).replace('<comment-id>', commentid);

    const commentData = {
      comment: {
        body: comment,
      },
    };

    if (mentions && mentions.length) {
      commentData.comment.mentions_list = mentions;
    }

    const formData = new FormData();
    addObjectToFormData(commentData, formData);

    const response = await this._http.put(url, formData);
    return response.data;
  }
  // END User reviews
}

export default new CommentsService();
